var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('Hamburger',{staticClass:"hamburger-container",attrs:{"toggle-click":_vm.toggleSideBar,"is-active":_vm.sidebar.opened}}),_vm._v(" "),_c('Breadcrumb'),_vm._v(" "),_c('div',{staticClass:"navbar-r"},[(_vm.device!=='mobile')?[_c('Admindrow')]:_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475e0680","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Navbar.vue
// module id = null
// module chunks = 